import './ReviewBlock.sass';

import React from 'react';

/**
 * Labelled box used by the review helpers shown under an editor
 * (content issues, spelling review). Both share this shell so they
 * stay visually identical.
 */
export default function ReviewBlock({ label, className = '', children }) {
  return (
    <div className={`review-block ${className}`.trim()}>
      <div className="review-block-label">{label}</div>
      <div className="review-block-body">{children}</div>
    </div>
  );
}
